





import Configuracion from '@/model/Configuracion'
import { configuracionStore } from '@/store'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import FormConfiguraciones from './FormConfiguraciones.vue'

@Component({
  components: { FormConfiguraciones },
})
export default class Configuraciones extends Vue {
  $refs: {
    busqueda: Vue & { buscar(): void }
    form: Vue & {
      onClose(): void
      openDialog(): void
      reset(): void
      resetValidation(): void
    }
  }
  mounted() {
    configuracionStore.load()
  }
  private get configuraciones() {
    return configuracionStore.configuracion
  }
  private loading = false
  createNewInstance() {
    return {
      mail: '',
      proximas: {
        dias: (undefined as unknown) as number,
        frecuencia: [],
      },
      vencidas: {
        frecuencia: [],
      },
    }
  }
  private formDisabled = false
  private async saveItem(item: Configuracion) {
    this.loading = true
    await configuracionStore.save(item)
    this.loading = false
  }
  private newInstance(formDisabled = false) {
    this.$refs.form.reset()
    this.formDisabled = formDisabled
  }
}
